import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/node_modules/.pnpm/next@15.5.2_@babel+core@7.25.8_@playwright+test@1.48.0_react-dom@19.1.1_react@19.1.1__react@19.1.1_sass@1.79.5/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/onlyoffice/src/client/packages/doceditor/src/providers/ErrorProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/onlyoffice/src/client/packages/doceditor/src/providers/ThemeProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/onlyoffice/src/client/packages/doceditor/src/providers/TranslationProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/packages/doceditor/src/styles/globals.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/onlyoffice/src/client/packages/doceditor/src/utils/registry.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toast"] */ "/app/onlyoffice/src/client/packages/shared/components/toast/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/packages/shared/styles/theme.scss");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/share.apple.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/share.facebook.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/share.google.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/share.linkedin.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/share.microsoft.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/share.twitter.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/share.weixin.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/share.zoom.react.svg");
